import { useEffect, useRef } from "react";

const INACTIVITY_TIMEOUT = 60 * 60 * 1000;

export const useInactivityTimer = (onTimeout: () => void) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onTimeout();
    }, INACTIVITY_TIMEOUT);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];

    const handleActivity = () => resetTimer();

    events.forEach(event => window.addEventListener(event, handleActivity));

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
